import { NgModule } from '@angular/core';
import { DocumentVersionListComponent } from './version-list.component';
import { FiVersionsListModule } from '@fi-app/utilities/versions-list/versions-list.module';

@NgModule({
    imports: [FiVersionsListModule],
    declarations: [DocumentVersionListComponent],
    exports: [DocumentVersionListComponent],
})
export class FiDocumentVersionListModule {}
